import classNames from 'classnames';

import BannerCenteredContent from 'components/Banner/BannerCenteredContent';

import type { ImageAndCTAProps } from './types';

import useStyles from './styles';

function ImageAndCTASkeleton({ reversed }: ImageAndCTAProps) {
  const styles = useStyles();
  const bannerClasses = classNames(styles.banner, {
    reversed,
  });

  return (
    <div className={styles.root}>
      <BannerCenteredContent className="banner-centered" autoDimensions>
        <div className={bannerClasses}>
          <div className={styles.mediaWrapper}>
            <div>
              <i className={classNames(styles.titleFallback, 'skeleton')} />
              <i className={classNames(styles.titleFallback, 'skeleton')} />
            </div>
            <i className={classNames(styles.mediaContainerFallback, 'skeleton')} />
          </div>

          <div className={styles.contentWrapper}>
            <i className={classNames(styles.featureFallback, 'skeleton')} />
            <i className={classNames(styles.featureFallback, 'skeleton')} />
            <i className={classNames(styles.featureFallback, 'skeleton')} />
            <i className={classNames(styles.featureFallback, 'skeleton')} />
            <i className={classNames(styles.buttonFallback, 'skeleton')} />
          </div>
        </div>
      </BannerCenteredContent>
    </div>
  );
}

export default ImageAndCTASkeleton;
